import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { AUTH_STATE_GUEST_COOKIE_NAME, AUTH_STATE_NEW_ACCOUNT_COOKIE_NAME, RoutePathname, } from '@as-react/common-types';
import { CookieUtil, getHomepageUrl } from '@as-react/common-utils';
import { Banner, Box, Spinner } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { ShoplandingLogin } from '../../components/checkout/login/shoplanding/ShoplandingLogin';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { useGuestLogin } from '../../hooks/useGuestLogin';
import { useOAuth } from '../../hooks/useOAuth';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { authActions } from '../../redux/authentication/actions/AuthActions.creators';
import { basketActions } from '../../redux/basket/actions/BasketActions.creators';
import checkoutActions from '../../redux/checkout/actions/CheckoutActions.creators';
import { generatePathUrl } from '../../util/URLParamUtil';
import { LoginLayout } from './CheckoutLoginContainer';
export const CheckoutLoginContainerNewAuth = () => {
    var _a;
    const { isShopLanding, root, isInAuthorMode, pageUrls } = useAemConfig();
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation([I18N_NAMESPACES.account, I18N_NAMESPACES.general]);
    const { guestLogin, errorMessage: guestErrorMessage, isPending: isGuestLoginPending } = useGuestLogin();
    const { loginState, isLoggedIn, redirectToLogin } = useOAuth({
        returnTo: `${root}buy.html`,
        flow: 'checkout',
        cancelUrl: (_a = pageUrls.basketOverview) !== null && _a !== void 0 ? _a : getHomepageUrl(root),
    });
    const guestError = t(guestErrorMessage || '');
    useEffect(() => {
        dispatch(basketActions.createGetAction());
        dispatch(authActions.createInitSocialAction());
        dispatch(analyticsActions.checkoutStep({ step: 2 }));
        dispatch(checkoutActions.createLoginAnalyticsAction());
        dispatch(checkoutActions.createSetHasRegistrationAction(false));
    }, []);
    useEffect(() => {
        const tld = window === null || window === void 0 ? void 0 : window.location.hostname.split('.').slice(-2).join('.');
        const isNewAccount = CookieUtil.get(AUTH_STATE_NEW_ACCOUNT_COOKIE_NAME);
        CookieUtil.delete(AUTH_STATE_NEW_ACCOUNT_COOKIE_NAME, tld);
        if (isLoggedIn) {
            history.replace(generatePathUrl(root, `buy.html/${isNewAccount ? RoutePathname.PERSONAL_DETAILS : RoutePathname.DELIVERY}`, isInAuthorMode));
            return;
        }
        if (isShopLanding || loginState === 'PENDING') {
            return;
        }
        const guestCookie = CookieUtil.get(AUTH_STATE_GUEST_COOKIE_NAME);
        if (guestCookie) {
            guestLogin(guestCookie);
            CookieUtil.delete(AUTH_STATE_GUEST_COOKIE_NAME, tld);
        }
        else {
            redirectToLogin();
        }
    }, [loginState, isLoggedIn, isShopLanding]);
    if (isShopLanding) {
        return (_jsx(LoginLayout, { children: _jsx(ShoplandingLogin, {}) }));
    }
    return (_jsxs(Box, { padding: "4", children: [guestError && _jsx(Banner, { text: guestError, status: "error" }), isGuestLoginPending && _jsx(Spinner, { fitContainer: true })] }));
};
